import type {
  SupplierDiversities,
  SupplierDiversitiesApi,
  SupplierDiversity,
  SupplierDiversityApi,
  SupplierDiversityFilters,
  SupplierDiversityFiltersUpdateApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

export const normalizeSupplierDiversity = (supplierDiversity: SupplierDiversityApi): SupplierDiversity => ({
  ...supplierDiversity,
  id: supplierDiversity.codeId ?? String(supplierDiversity.id),
  label: supplierDiversity.codeDesc,
});

export const normalizeSupplierDiversities = (response: SupplierDiversitiesApi): SupplierDiversities => {
  const list = (response.items ?? [])
    .sort((a, b) => a.codeDesc.localeCompare(b.codeDesc))
    .map(normalizeSupplierDiversity);
  return {
    list,
    map: list.reduce(
      (acc, supplierDiversity) => {
        acc[String(supplierDiversity.id)] = supplierDiversity;
        return acc;
      },
      {} as SupplierDiversities['map'],
    ),
  };
};

export const normalizeSupplierDiversityFilters = (
  filters: Partial<SupplierDiversityFilters>,
): SupplierDiversityFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
    Sorting: 'codeDesc asc',
  };
};
